import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Alert, Button, Form, Modal, Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  FaComments,
  FaEnvelope,
  FaForumbee,
  FaPhone,
  FaShieldAlt,
  FaUserCircle,
} from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { toast } from "react-toastify";
import {
  useFetchProfilesQuery,
  useUpdateUserMutation,
  useFetchGameStatesQuery,
  useFetchNearByFansQuery,
  useSendMessageMutation,
} from "../../store/api/apiSlice";
import { Button as CustomBtn, Input } from "../../ui";
import CustomModal from "../customModal/customModal";
import CustomForm from "../form/form";
import { useForumContext } from "../context/ForumContext";
import { useTheme } from "../context/ThemeContext";
const baseUrl = process.env.REACT_APP_SERVER_URL;

const Header = () => {
  const { fgColor, bgColor } = useTheme();
  const { handleMyForumClick, setSelectedForum } = useForumContext();
  const [isModalVisible, setModalVisible] = useState(false);
  const [isPTGVisible, setIsPTGVisible] = useState(false);
  const [isNearMeVisible, setIsNearMeVisible] = useState(false);
  const [sendMessage] = useSendMessageMutation();
  const [shouldFetchNearByFans, setShouldFetchNearByFans] = useState(false);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const {
    data: profileData,
    error,
    isLoading,
    refetch: refetchProfileData,
  } = useFetchProfilesQuery();

  const handleMyForumClickWrapper = (profileId) => {
    navigate("/forumlist");
    handleMyForumClick(profileId);
    setSelectedForum("myForum");
  };
  const [successMsg, setSuccessMsg] = useState("");
  const [messageText, setMessageText] = useState("");
  const token = JSON.parse(localStorage.getItem("token"));
  const { data: fetchGameStates } = useFetchGameStatesQuery(token?.userId);

  const userCreatedat = JSON.parse(localStorage.getItem("user"))?.createdAt;
  const userCreatedDateTime = new Date(userCreatedat);
  const gameDeadline = moment(userCreatedDateTime).add(15, "days").toDate();
  const currentDateTime = new Date();
  const {
    data: fetchNearByFans,
    refetch: refetchfetchNearByFans,
    isLoading: isLoadingNearByFans,
    error: nearByFansError,
  } = useFetchNearByFansQuery(token?.userId, {
    skip: !shouldFetchNearByFans || !token?.userId, // This prevents auto-calling
  });
  const timeLeftMilliseconds =
    gameDeadline.getTime() - currentDateTime.getTime();
  let formattedTimeLeft;

  if (timeLeftMilliseconds < 0) {
    formattedTimeLeft = "0D 0H 0M";
  } else {
    const duration = moment.duration(timeLeftMilliseconds);
    formattedTimeLeft = `${Math.floor(
      duration.asDays()
    )}D ${duration.hours()}H ${duration.minutes()}M`;
  }

  const handleCloseModal = () => {
    setSubmitBtn(false);
    setModalVisible(false);

    setSuccessMsg("");
  };

  useEffect(() => {}, [isModalVisible]);
  const handleShowModal = () => setModalVisible(true);
  const handlePTGShowModal = () => {
    setIsPTGVisible(true);
  };
  const handleClosePTGModal = () => {
    setIsPTGVisible(false);
  };
  const handleNearMeShowModal = () => {
    setShouldFetchNearByFans(true);
    setIsNearMeVisible(true);
    if (token?.userId) {
      setTimeout(() => {
        refetchfetchNearByFans();
      }, 100);
    }
  };
  const handleNearMeCloseModal = () => {
    setIsNearMeVisible(false);
  };
  const [submitBtn, setSubmitBtn] = useState(false);
  const handlesSubmit = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    setSubmitBtn(true);

    try {
      const newMessage = {
        userId: profileData?.user?._id,
        forumId: "0",
        receiverId: "0",
        message: messageText,
        messageType: "text",
        type: "private",
        messageNote: "forAdmin",
        status: true,
      };
      const response = await sendMessage(newMessage).unwrap();
      if (response.message === "Message Created Successfully") {
        setSubmitBtn(false);
        setMessageText("");
        toast.success("Message sent Successfully!");
      }
    } catch (error) {
      setSubmitBtn(false);

      toast.error("Failed to send message.");
    }
  };

  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profile, setProfile] = useState({
    name: "David",
    avatarName: "RebYeller",
    email: "abc@cssfa.com",
    phone: "662-292-2327",
    address: "617 Anyplace Rd, Memphis, TN 38567",
    image: "image",
    isAdmin: false,
  });
  const [updateUser] = useUpdateUserMutation();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const phoneRef = useRef();

  const openModal = () => {
    handleClose();
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
    setMenuVisible(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
      setMenuVisible(false);
    }
  };

  useEffect(() => {
    refetchProfileData();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const [unreadMessages, setUnreadMessages] = useState({
    unreadPrivateMessages: 0,
    unreadForumMessages: 0,
  });
  const handleShow = async () => {
    refetchProfileData();
    const token = JSON.parse(localStorage.getItem("token"));
    const xAuthToken = token ? token.token : null;
    const userData = JSON.parse(localStorage.getItem("user"));
    const creatorId = userData ? userData._id : null;

    if (creatorId) {
      try {
        const response = await fetch(
          `${baseUrl}/api/messages/getUnreadMessages?userId=${creatorId}`,
          {
            method: "GET",
            headers: {
              "secret-key": secretKey,
              "x-auth-token": xAuthToken,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();

          setUnreadMessages(data);
        } else {
        }
      } catch (error) {}
    } else {
    }

    setShow(true);
  };
  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible((prev) => !prev);
    setDropdownOpen(false);
  };

  useEffect(() => {
    if (profileData) {
      setProfile({
        firstName: profileData.user.firstName || "",
        lastName: profileData.user.lastName || "",
        memberid: profileData.user.memberid || "",
        avatarName: profileData.user.avatarName || "",
        email: profileData.user.email || "",
        phone: profileData.user.phone || "",
        image: profileData.user.image,
        isAdmin: profileData.user.isAdmin,
      });
    }
  }, [profileData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const firstName = firstNameRef.current.value;
    const lastName = lastNameRef.current.value;
    const phone = phoneRef.current.value;

    if (!firstName || !lastName || !phone) {
      return;
    }

    try {
      await updateUser({
        firstName,
        lastName,
        phone,
      }).unwrap();
      closeModal();
      toast.success("User Updated successfulasasly!");
    } catch (err) {}
  };

  const parseJSONOrDefault = (data, defaultValue = []) => {
    if (data && data.length > 0) {
      try {
        const parsedData = JSON.parse(data[0]);
        return Array.isArray(parsedData) ? parsedData : defaultValue;
      } catch (error) {
        return defaultValue;
      }
    }
    return defaultValue;
  };
  const [shareMe, setShareMe] = useState(profileData?.user?.shareMe);
  useEffect(() => {
    setShareMe(profileData?.user?.shareMe);
  }, [profileData]);
  const updateShareMeStatus = async (value) => {
    const formData = new FormData();
    formData.append("shareMe", value);

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const response = await fetch(`${baseUrl}/api/auth/update-profile`, {
        method: "PUT",
        headers: {
          "secret-key": secretKey,
          "x-auth-token": xAuthToken,
        },
        body: formData,
      });

      if (response.ok) {
        toast.success("Status updated successfully");
        setShareMe(value);
      } else {
        const errorData = await response.json();
      }
    } catch (error) {}
  };

  const handleRadioChange = (e) => {
    e.stopPropagation();
    const value = e.target.value === "share";
    updateShareMeStatus(value);
  };
  const favoriteSports = parseJSONOrDefault(profileData?.user?.favorite_sports);
  const favoriteAthelete = parseJSONOrDefault(
    profileData?.user?.favorite_athletes
  );

  const interestedSchools = parseJSONOrDefault(
    profileData?.user?.interested_schools
  );
  const handleSend = () => {
    navigate("/chat");
  };

  if (error) {
    return <h1>Error loading profiles</h1>;
  }

  return (
    <>
      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        className="customModalWidth"
      >
        <h3 className="modalHeading borderb">Update Profile</h3>
        <div className="inviteForm">
          <CustomForm onSubmit={handleSubmit} className="col-10 mx-auto">
            <div className="d-flex flex-column row">
              <p className="fieldWrapper col-12">
                <Input
                  label="First Name"
                  name="firstName"
                  type="text"
                  value={profile.firstName}
                  ref={firstNameRef}
                  onChange={handleInputChange}
                />
              </p>
              <p className="fieldWrapper col-12">
                <Input
                  label="Last Name"
                  name="lastName"
                  type="text"
                  value={profile.lastName}
                  ref={lastNameRef}
                  onChange={handleInputChange}
                />
              </p>
              <p className="fieldWrapper col-12">
                <Input
                  label="Email"
                  name="email"
                  type="text"
                  value={profile.email}
                  ref={lastNameRef}
                />
              </p>
              <p className="fieldWrapper col-12">
                <Input
                  label="Phone"
                  name="phone"
                  type="text"
                  value={profile.phone}
                  ref={phoneRef}
                  onChange={handleInputChange}
                />
              </p>

              <p className="fieldWrapper col-12">
                <Input
                  label="Favourite sports"
                  name="Favourite sports"
                  type="text"
                  value={profile.favorite_sports}
                />
              </p>
            </div>
            <div className="btnPosition">
              <Button onClick={closeModal}>Cancel</Button>
              <Button type="submit">Save</Button>
            </div>
          </CustomForm>
        </div>
      </CustomModal>

      <section className="whitebg">
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-12">
              <header className="header ">
                <div className="logo-section Header_logo_div">
                  <a href="/">
                    <img
                      src="/images/headericon.png"
                      alt="Logo"
                      className="logo hiddensm"
                    />
                  </a>
                  <img
                    src="/images/burger.png"
                    alt="Burger Menu"
                    className="burgericon"
                    onClick={toggleMenu}
                  />
                  {menuVisible && (
                    <ul
                      ref={dropdownRef}
                      className={`dropdown-menu ${menuVisible ? "show" : ""}`}
                      style={{
                        position: "absolute",
                        zIndex: "10",
                        background: "#fff",
                        top: "100%",
                        left: 89,
                        width: "161px",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                        padding: "10px",
                        borderRadius: "5px",

                        color: "black",
                      }}
                    >
                      <li className="menu-item Header_dropdown_menuLi">
                        <Link className="Header_link_chat" to="/chat">
                          <FaComments className="Header_Icon" />
                          Chat
                        </Link>
                      </li>
                      <li className="menu-item Header_dropdown_menuLi">
                        <Link className="Header_link_chat" to="/forumlist">
                          <FaForumbee className="Header_Icon" />
                          Forum
                        </Link>
                      </li>
                      <li className="menu-item Header_dropdown_menuLi">
                        <a
                          href="https://csfa-us.org"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="Header_link_chat"
                        >
                          <FaShieldAlt className="Header_Icon" />
                          CSFA-US
                        </a>
                      </li>
                      <li className="menu-item Header_dropdown_menuLi">
                        <a
                          href="https://csfa-us.org/csfa-build"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="Header_link_chat"
                        >
                          <FaShieldAlt className="Header_Icon" />
                          CSFA-BUILD
                        </a>
                      </li>
                      <li
                        className="menu-item Header_dropdown_menuLi"
                        onClick={handleShowModal}
                      >
                        <FaUserCircle className="Header_Icon" />
                        <span className="Header_link_chat">Contact Admin</span>
                      </li>

                      <li className="menu-item Header_dropdown_menuLi">
                        <Link className="Header_link_chat" to="/PrivacyPolicy">
                          <FaEnvelope className="Header_Icon" />
                          Privacy Policy
                        </Link>
                      </li>
                    </ul>
                  )}
                  <Modal
                    className="p-3"
                    show={isModalVisible}
                    onHide={handleCloseModal}
                  >
                    <Modal.Header className="p-3 contact_header">
                      <img
                        src="/images/headericon.png"
                        alt="Logo"
                        className="contact_header_img"
                      />
                      <Modal.Title className="contact_header_title">
                        Contact Form
                      </Modal.Title>
                      <Button
                        variant="danger"
                        onClick={handleCloseModal}
                        className="contact_header_Btn"
                      >
                        &times;
                      </Button>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center mb-2">
                        <FaPhone className="contact_header_icon" />
                        <span className="p-2 contact_header_text">
                          {" "}
                          <a
                            href="tel:+12052596913"
                            className="contact_header_text_url"
                          >
                            (205) 259-6913
                          </a>
                        </span>
                        <FaEnvelope className="contact_header_text_url" />
                        <span className="p-2">
                          {" "}
                          <a
                            href="mailto:voice@csfa-us.org"
                            className="contact_header_text_url"
                          >
                            voice@csfa-us.org
                          </a>
                        </span>
                      </div>
                      <Form onSubmit={handlesSubmit}>
                        {successMsg && (
                          <Alert variant="success">{successMsg}</Alert>
                        )}
                        <Form.Group controlId="message">
                          <Form.Label>Message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={messageText}
                            onChange={(e) => setMessageText(e.target.value)}
                            placeholder="Type your message here..."
                            required
                          />
                        </Form.Group>
                        <div className="pt-3">
                          <CustomBtn
                            loading={submitBtn}
                            variant="primary"
                            type="submit"
                          >
                            Submit
                          </CustomBtn>
                        </div>
                      </Form>
                    </Modal.Body>
                  </Modal>
                </div>
                <div className=" title-section2">
                  <a href="/">
                    <img
                      src="/images/headericon.png"
                      alt="Logo2"
                      className="logo2 hiddenlg"
                    />
                  </a>
                  <h1>Collegiate Sports Fans Association</h1>
                </div>
                <div className="profile-section" ref={dropdownRef}>
                  <div className="profile-menu" onClick={toggleDropdown}>
                    <img
                      src={`${baseUrl}/${profile.image}` || <Skeleton />}
                      alt={profile.avatarName}
                      className="profile-pic"
                    />
                    <span className="profile-name">
                      {profile.firstName}{" "}
                      <IoIosArrowDown className="dropdownicon" />
                    </span>
                  </div>
                  {isDropdownOpen && (
                    <ul
                      className={`dropdown-menu2 ${
                        isDropdownOpen ? "show" : ""
                      }`}
                      style={{
                        position: "absolute",
                        zIndex: "1001111",
                        background: "#fff",
                        top: "100%",

                        width: "200px",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <li className="header_li_pointer" onClick={handleShow}>
                        <img
                          src="/images/profile.png"
                          alt="Profile"
                          className="profileicon"
                        />
                        My Profile
                      </li>
                      {profile.isAdmin && (
                        <li onClick={() => navigate("/admin")}>
                          <img
                            src="/images/admin.png"
                            alt="Admin"
                            className="profileicon"
                          />
                          Admin
                        </li>
                      )}
                      <li onClick={handleShowModal}>
                        <img
                          src="/images/contact.png"
                          alt="Profile"
                          className="profileicon"
                          onClick={handleShowModal}
                        />
                        Contact
                      </li>

                      <li
                        onClick={() => {
                          console.log("Logging out...");
                          localStorage.removeItem("token");
                          localStorage.removeItem("user");
                          localStorage.removeItem("textColor");
                          localStorage.removeItem("backgroundColor");
                          console.log("Local storage cleared.");
                          navigate("/login");
                        }}
                      >
                        <img
                          src="/images/logout.svg"
                          alt="Profile"
                          className="logoutIcon"
                        />
                        Logout
                      </li>
                    </ul>
                  )}
                </div>
              </header>
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-right"
        backdrop="static"
        keyboard={false}
        className="right"
        style={{
          scrollbarColor: bgColor ? `${bgColor} #f1f1f1` : "#704fe6 #f1f1f1",
          scrollbarWidth: "thin",
        }}
      >
        <Modal.Header>
          <Modal.Title>My Profile</Modal.Title>
          <MdCancel onClick={handleClose} className="closeicon" />
        </Modal.Header>
        {isLoading ? (
          <div className="loader">Loading...</div>
        ) : (
          <Modal.Body>
            <div className="tbal-content">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Personal Information</h4>

                <Button onClick={() => navigate("/updateprofile")}>
                  Edit Profile
                </Button>
              </div>
              <div className="table-responsive py-3">
                <table className="table_Container">
                  <tbody>
                    <tr>
                      <td className="tabel_div1">Member #</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3"> {profile.memberid}</td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Name </td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profile.firstName + " " + profile.lastName}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Avatar Name</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profile?.avatarName || ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Email </td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">{profileData?.user?.email}</td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Phone </td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">{profileData?.user?.phone}</td>
                    </tr>

                    <tr>
                      <td className="tabel_div1">Street Address</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.address?.streetAddress}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">City</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.address?.city}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">State</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.address?.state}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Zip</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.address?.zip}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div4">My College</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.school_name
                          ? profileData.user.school_name
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Membership</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.payment?.package_name}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">Reffered By</td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        {profileData?.user?.referredBy}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="tbal-content">
              <h4>
                3 Sports and the Associated College of that Sport I would like
                to Follow
              </h4>
              <div className="table-responsive py-3">
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <tbody>
                    {favoriteSports.map((sport, index) => (
                      <tr key={index}>
                        <td className="tabel_div1">{sport.name || ""}</td>
                        <td className="tabel_div2">:</td>
                        <td className="tabel_div3">
                          {sport.school || "No school available"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="tbal-content">
              <h4>3 Player You’d like to Follow</h4>
              <div className="table-responsive py-3">
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <tbody>
                    {favoriteAthelete.map((athelete, index) => (
                      <tr key={index}>
                        <td className="tabel_div1">{athelete.name || ""}</td>
                        <td className="tabel_div2">:</td>
                        <td className="tabel_div3">{athelete.school || ""}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {isPTGVisible && (
              <CustomModal isOpen={isPTGVisible} onClose={handleClosePTGModal}>
                <h3 className="recruit_invited_heading">Recruit(s) Invited</h3>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Invited Date</th>

                      <th>Is Signup</th>
                      <th>Is Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchGameStates?.stats?.invitees.map((invitee) => (
                      <tr key={invitee._id}>
                        <td>{invitee.invitee_fname}</td>
                        <td>{invitee.invitee_lname}</td>
                        <td>
                          {invitee.addedDate
                            ? (() => {
                                const date = new Date(invitee.addedDate);
                                const month = String(
                                  date.getUTCMonth() + 1
                                ).padStart(2, "0");
                                const day = String(date.getUTCDate()).padStart(
                                  2,
                                  "0"
                                );
                                const year = date.getUTCFullYear();
                                return `${month}/${day}/${year}`;
                              })()
                            : "unknown"}
                        </td>

                        <td>{invitee.signedup ? "Yes" : "No"}</td>
                        <td>{invitee.isPaid ? "Yes" : "No"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CustomModal>
            )}
            {isNearMeVisible && (
              <CustomModal
                isOpen={isNearMeVisible}
                onClose={handleNearMeCloseModal}
              >
                <h3 className="recruit_invited_heading">Fans Near Me</h3>

                {fetchNearByFans?.nearbyUsers?.length > 0 ? (
                  <Table striped bordered hover>
                    <tbody>
                      {fetchNearByFans?.nearbyUsers?.map((fan) => (
                        <tr
                          key={fan?.id}
                          style={{
                            cursor: "pointer",
                            transition: "background-color 0.2s ease",
                          }}
                        >
                          <td className="border-0">
                            <div className="fs-2 d-flex align-items-center justify-content-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-circle-user-round-icon lucide-circle-user-round"
                              >
                                <path d="M18 20a6 6 0 0 0-12 0" />
                                <circle cx="12" cy="10" r="4" />
                                <circle cx="12" cy="12" r="10" />
                              </svg>
                            </div>
                          </td>
                          <td className="border-0 align-middle">{fan.name}</td>
                          <td className="border-0 align-middle text-end">
                            {fan?.distanceInKm} KM
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div className="text-center py-5">
                    <div className="mb-4">
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="mx-auto opacity-50"
                      >
                        <path
                          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <h5 className="text-muted mb-2">No Fans Nearby</h5>
                    <p className="text-muted mb-0 fs-6">
                      There are currently no fans in your area.
                      <br />
                    </p>
                  </div>
                )}
              </CustomModal>
            )}
            <div className="tbal-content margin_bottom">
              <div
                className="table-responsive py-3"
                style={{ overflow: "hidden" }}
              >
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td className="tabel_div1">
                        {" "}
                        <a className="table_text_url">My Chat</a>
                      </td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        <a
                          className="MyNewMessage"
                          onClick={handleSend}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            width="26"
                            height="26"
                            src="https://img.icons8.com/windows/32/new-post.png"
                            alt="new-post"
                            style={{ marginRight: "8px", cursor: "pointer" }}
                          />{" "}
                          {unreadMessages.unreadPrivateMessages} New Messages
                        </a>{" "}
                      </td>
                    </tr>
                    <tr>
                      <td className="tabel_div1">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            e.preventDefault();
                            handleMyForumClickWrapper(profileData?.user._id);

                            handleClose();
                          }}
                          className="table_text_url"
                        >
                          My Forum
                        </a>
                      </td>
                      <td className="tabel_div2">:</td>
                      <td className="tabel_div3">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();

                            handleMyForumClickWrapper(profileData?.user._id);

                            handleClose();
                          }}
                          className="MyNewMessage tabel_text_urlTag"
                        >
                          <img
                            width="26"
                            height="26"
                            src="https://img.icons8.com/windows/32/new-post.png"
                            alt="new-post"
                            style={{ marginRight: "8px" }}
                          />{" "}
                          {unreadMessages.unreadForumMessages} New Forum
                          Messages
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h4>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onClick={handleNearMeShowModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-map-pin-icon lucide-map-pin"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>{" "}
                  Find Fans Near Me
                </div>
                <div className="sidebar_findFan_div">
                  <label className="sidebar_findFan_label">
                    <input
                      type="radio"
                      name="shareOption"
                      value="dontShare"
                      checked={!shareMe}
                      onChange={handleRadioChange}
                      style={{ accentColor: "#ce1126" }}
                    />
                    <span className="sidebar_findFan_dontShare">
                      Don’t Share Me
                    </span>
                  </label>
                  <label className="sidebar_findFan_label">
                    <input
                      type="radio"
                      name="shareOption"
                      value="share"
                      checked={shareMe}
                      onChange={handleRadioChange}
                      style={{ accentColor: "#ce1126" }}
                    />
                    <span className="sidebar_findFan_dontShare">Share Me</span>
                  </label>
                </div>
              </h4>
              <h4>Play The Game </h4>

              <div
                className="table-responsive py-3"
                style={{ overflowX: "inherit" }}
              >
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td className="table_games_div1">
                        Time Remaining in Game
                      </td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div3">{formattedTimeLeft}</td>
                    </tr>
                    <tr>
                      <td className="table_games_div1"># Recruits Invited</td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div3">
                        {fetchGameStates?.stats?.totalInvitees}
                      </td>
                    </tr>
                    <tr>
                      <td className="table_games_div1"># Recruits Signed up</td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div3">
                        {fetchGameStates?.stats?.totalSignups}
                      </td>
                    </tr>
                    <tr>
                      <td className="table_games_div1">Current PTG Level</td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div4">
                        {fetchGameStates?.stats?.userPTGlevel}
                      </td>
                    </tr>
                    <tr>
                      <td className="table_games_div1">
                        PTG Prizes Awarded/Claimed
                      </td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div3">N/A</td>
                    </tr>
                    <tr>
                      <td className="table_games_div5">PTG Report</td>
                      <td className="table_games_div6">:</td>
                      <td className="table_games_div7">
                        <a
                          className="tabel_ptg_report"
                          onClick={handlePTGShowModal}
                        >
                          PTG Report
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="tbal-content">
              <h4>Available Giveaways</h4>
              <div className="table-responsive py-3">
                <table style={{ width: "100%", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td className="table_games_div5">#Giveaways</td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div8">
                        {fetchGameStates?.stats?.totalSignups}
                      </td>
                    </tr>
                    <tr>
                      <td className="table_games_div5">
                        #Donated TO CSFA-BUILD
                      </td>
                      <td className="table_games_div2">:</td>
                      <td className="table_games_div8">0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export default Header;
